export function calcDisplayColumns(columns, head, showAll = false) {
    let result;
    if (head.length) {
        result = [];
        head.forEach(item => {
            const { isShow, dataIndex } = item;
            if (isShow === '1' || showAll) {
                const column = columns.find(i => i.dataIndex === dataIndex) || {};
                result.push(column);
            }
        });
    } else {
        result = columns;
    }
    return result;
}


// WEBPACK FOOTER //
// ./src/components/contractManagement/requestRecord/common.js